import Carousel from '@components/Carousel'
import {
  faCss3,
  faGitAlt,
  faGolang,
  faHtml5,
  faJsSquare,
  faReact,
} from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useEffect, useState, useMemo } from 'react'
import { aboutImages, getImageUrls } from '@/utils/imageLoaders'
import './index.scss'

const About = () => {
  const carouselImages = useMemo(() => getImageUrls(aboutImages), [])

  const [currentImageIndex, setCurrentImageIndex] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => {
        return prevIndex === carouselImages.length - 1 ? 0 : prevIndex + 1
      })
    }, 5000)
    return () => clearInterval(interval)
  }, [carouselImages.length])

  return (
    <div className="about-page relative ms-16 md:ms-24 lg:ms-32 p-4 md:p-8 w-auto">
      <div className="about-container max-w-[1400px] mx-auto">
        {/* Carousel and Tech Stack Section */}
        <div className="hero-section flex flex-col lg:flex-row items-center lg:items-start justify-between gap-8 lg:gap-16 mb-12">
          {/* Carousel Section */}
          <div className="carousel-wrapper flex-shrink-0 w-full lg:w-[55%] max-w-[600px]">
            <Carousel
              imgSrc={carouselImages[currentImageIndex]}
              height={450}
              maxHeight={450}
            />
          </div>

          {/* Tech Stack Cube Section */}
          <div className="tech-stack-cube flex-shrink-0 flex justify-center lg:justify-start items-center relative z-20">
            <div className="cubespinner">
              <div
                className="face1
                absolute
                w-[200px]
                h-[200px]
                border
                border-gray-300
                bg-white/80
                flex
                justify-center
                items-center
                text-[100px]
                shadow-[0_0_16px_0_lightyellow]
              "
              >
                <FontAwesomeIcon icon={faReact} color="#5ED4F4" />
              </div>
              <div
                className="face2
                absolute
                w-[200px]
                h-[200px]
                border
                border-gray-300
                bg-white/80
                flex
                justify-center
                items-center
                text-[100px]
                shadow-[0_0_16px_0_lightyellow]
              "
              >
                <FontAwesomeIcon icon={faHtml5} color="#F06529" />
              </div>
              <div
                className="face3
                absolute
                w-[200px]
                h-[200px]
                border
                border-gray-300
                bg-white/80
                flex
                justify-center
                items-center
                text-[100px]
                shadow-[0_0_16px_0_lightyellow]
              "
              >
                <FontAwesomeIcon icon={faCss3} color="#28A4D9" />
              </div>
              <div
                className="face4
                absolute
                w-[200px]
                h-[200px]
                border
                border-gray-300
                bg-white/80
                flex
                justify-center
                items-center
                text-[100px]
              "
              >
                <FontAwesomeIcon icon={faJsSquare} color="#EFD81D" />
              </div>
              <div
                className="face5
                absolute
                w-[200px]
                h-[200px]
                border
                border-gray-300
                bg-white/80
                flex
                justify-center
                items-center
                text-[100px]
                shadow-[0_0_16px_0_lightyellow]
              "
              >
                <FontAwesomeIcon icon={faGitAlt} color="#EC4D28" />
              </div>
              <div
                className="face6
                absolute
                w-[200px]
                h-[200px]
                border
                border-gray-300
                bg-white/80
                flex
                justify-center
                items-center
                text-[100px]
                shadow-[0_0_16px_0_lightyellow]
              "
              >
                <FontAwesomeIcon icon={faGolang} color="#28A4D9" />
              </div>
            </div>
          </div>
        </div>

        {/* About Text Section */}
        <div
          className="about-text
          text-white
          grid
          gap-y-6
          font-sans
          text-lg
          leading-[1.5]
          max-w-[800px]
          mx-auto
          px-4
          pb-12
          relative
          z-10
          before:content-['<p>']
          before:font-la-belle-aurore
          before:text-primary
          before:text-4xl
          before:opacity-60
          before:block
          before:mb-2
          after:content-['</p>']
          after:font-la-belle-aurore
          after:text-primary
          after:text-4xl
          after:opacity-60
          after:block
          after:mt-2
        "
        >
          <h3 className="text-primary text-4xl text-center my-1">About me</h3>
          <p className="mt-0 text-2xl animate-pulseOnce delay-[200ms]">
            Welcome to my portfolio! I'm a seasoned Full Stack Developer with
            5-7 years of experience, specializing in the front-end. Proficient
            in Java, Python, and Go. (Currently learning O🐫)
          </p>
          <p className="mt-0 text-2xl animate-pulseOnce delay-[1400ms]">
            Beyond tech, I'm enthusiastic about exploring new places, fueling my
            creativity through travel. In my free time, I enjoy working on
            diverse side projects that allow me to stretch my skills and think
            outside the box.
          </p>
        </div>
      </div>
    </div>
  )
}

export default About
